import { createFileRoute } from '@tanstack/react-router';
import { Box } from 'components/Box';
import { Button } from 'components/Button';
import HeaderWithCloseLabel from 'components/HeaderWithCloseLabel/HeaderWithCloseLabel.component';
import Icon from 'components/Icon/Icon.component';
import redCheckCircle from 'images/icons/pokerstars/error-circle-red.svg';
import { Translate } from 'react-localize-redux';
import { Text } from 'style/text.style';

export const Route = createFileRoute('/upload-bank-info-error')({
  component: UploadBankInfoError,
});
function UploadBankInfoError() {
  const navigate = Route.useNavigate();

  const handleClose = () => {
    navigate({ to: '/' });
  };

  return (
    <>
      <HeaderWithCloseLabel closeLink={'/'} headerHeight="40px" />

      <Box
        display={'flex'}
        justifyContent={'center'}
        width={'100vw'}
        height={'100vh'}
        backgroundColor="#fff"
      >
        <Box
          maxWidth={604}
          width={'100%'}
          margin={'0 auto'}
          padding={'48px 16px'}
          display={'flex'}
          flexDirection={'column'}
          gap="24px"
        >
          <Box
            padding={16}
            border={'1px solid rgba(191, 191, 191, 1)'}
            borderRadius={8}
            display={'flex'}
            flexDirection={'column'}
          >
            <Icon
              margin="0 auto"
              iconSize={'56px'}
              height={'56px'}
              iconSrc={redCheckCircle}
            />
            <Text textSize={'18px'} textWeight={600} margin={'24px 0 8px 0'}>
              <Translate id="lbl.somethingWentWrong" />
            </Text>
            <Text textSize={'14px'}>
              <Translate id="lbl.serviceNotAvailableTryAgainLater" />
            </Text>
          </Box>
          <Button onClick={handleClose} marginLeft={'auto'}>
            <Translate id="lbl.close" />
          </Button>
        </Box>
      </Box>
    </>
  );
}
